import { apiClient } from "helpers/api_helper";
import { API } from "../constant/po.api";

export const getSearchPoProductList = async (data: object) => {
    try {
        const response = await apiClient.post(API.SEARCH_PRODUCT_FOR_PO, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createPO = async (data: any) => {
    try {
        const response = await apiClient.post(API.CREATE_PO_FOR_ITEM_MASTER, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getVendorList = async () => {
    try {
        const response = await apiClient.get(API.Get_Vendor_Slect_List);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};